import transferItemReducer from "./reducers";

export default transferItemReducer;
